import Vue from 'vue'
const WidgetFormBus = new Vue()
export default WidgetFormBus